export default __webpack_public_path__ + "static/media/psmall.cffe8d10.jpg";